import { v4 as uuidv4 } from "uuid";

export function generateRequestId() {
  return uuidv4();
}
